<script setup>
import moment from "moment";
import { statusIMKPEnum } from "@/utilities/enum";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 my-5">
      <v-col cols="12">
        <div
          class="w-100 border border-1 pt-2 shadow-sm"
          style="
            min-height: 5vh;
            background-color: #f8d7da;
            border-radius: 1rem;
          "
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Preview Data IMKP
          </div>
          <div
            class="bg-white w-100 border border-1 shadow-sm p-2 rounded-4"
            style="min-height: 60vh"
          >
            <div
              class="d-flex justify-content-between px-4 pt-4 align-items-center justify-content-between"
            >
              <div
                class="col-md-6 d-flex"
                style="
                  padding-left: 0.5rem;
                  padding-top: 0.5rem;
                  align-items: flex-start;
                "
              >
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt="logo-borneo-indobara"
                  class="img-fluid"
                  style="width: 13%"
                />
                <div style="padding-top: 2%">
                  <h5 class="fw-bold">PT BORNEO INDOBARA</h5>
                </div>
              </div>
              <img
                src="../../assets/logo-sinisaja.png"
                alt="logo-sini-saja"
                class="img-fluid"
                style="width: 10%"
              />
            </div>
            <h6 class="fw-bold text-end text-nowrap m-2">
              BIB-HSE-PPO-F-071-01
            </h6>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                IZIN MELAKSANAKAN KEGIATAN PROYEK
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Sebagai persyaratan untuk melaksanakan kegiatan proyek di dalam
                area kerja PT Borneo Indobara
              </p>
              <div class="rounded shadow-sm mb-4">
                <table class="table table-striped w-100 rounded">
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">A. DETAIL IZIN</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <TableComponent
                      :data="detailIzin"
                      :column="2"
                      :subTitle="false"
                    />
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">B. DETAIL PEKERJAAN</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 ms-2 m-0">Uraian Pekerjaan</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="no-style">
                        <div
                          class="ms-4 w-100 fs-8"
                          style="
                            white-space: pre-line;
                            word-break: break-word;
                            overflow-wrap: break-word;
                          "
                        >
                          {{ imkp?.deskripsiPekerjaan }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">
                          C. PENCEGAHAN / PERSYARATAN KHUSUS
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="2" style="background: #f8e3e5">
                        <div class="row fw-bold ms-2 fs-8 m-0">
                          <div class="col-8">Daftar Periksa</div>
                          <div class="col-2 text-center">Y</div>
                          <div class="col-2 text-center">T</div>
                        </div>
                      </td>
                      <td colspan="2" style="background: #f8e3e5">
                        <div class="row fw-bold ms-2 fs-8 m-0">
                          <div class="col-8">Daftar Periksa</div>
                          <div class="col-2 text-center">Y</div>
                          <div class="col-2 text-center">T</div>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="(data, index) in persyaratanKhusus" :key="index">
                      <td
                        colspan="2"
                        class="no-style"
                        v-for="(item, index) in data"
                        :key="index"
                      >
                        <div class="row fs-8 ms-2 m-0">
                          <div class="col-8" v-html="item?.name"></div>
                          <div class="col-2 text-center">
                            {{ item?.file?.length >= 1 ? "✓" : "" }}
                          </div>
                          <div class="col-2 text-center">
                            {{ item?.file?.length === 0 ? "✓" : "" }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 ms-2 m-0">Tindakan Pencegahan Lainnya</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="no-style">
                        <div
                          class="ms-4 w-100 fs-8"
                          style="
                            white-space: pre-line;
                            word-break: break-word;
                            overflow-wrap: break-word;
                          "
                        >
                          {{ imkp?.tindakPencegahan }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">
                          D. PENGESAHAN UNTUK IZIN MELAKSANAKAN KEGIATAN PROYEK
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 fw-bold ms-2 m-0">
                          Penanggung Jawab Operasional (PJO)
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Nama</p>
                      </td>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Jabatan</p>
                      </td>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Tanggal</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanda Tangan</p>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center align-bottom no-style border-end">
                        <p class="fs-7 m-0">
                          {{ pjo.name }}
                        </p>
                      </td>
                      <td class="text-center align-bottom border-end">
                        <p class="fs-7 m-0">
                          {{ pjo.jabatan }}
                        </p>
                      </td>
                      <td class="text-center align-bottom border-end">
                        <p class="fs-7 m-0">
                          {{
                            imkp?.tglTtdPjo
                              ? moment(new Date(imkp?.tglTtdPjo)).format(
                                  "DD MMMM YYYY",
                                )
                              : "-"
                          }}
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <img
                            :src="ttdPjoFile"
                            alt="ttd-pjo"
                            style="height: 5rem; mix-blend-mode: multiply"
                            class="text-center"
                            :class="{
                              'd-none': !ttdPjoFile,
                            }"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 fw-bold ms-2 m-0">Dept Head Kustodian</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Nama</p>
                      </td>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Jabatan</p>
                      </td>
                      <td style="background: #f8e3e5" class="border-end">
                        <p class="fs-8 fw-bold m-0 text-center">Tanggal</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanda Tangan</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="text-center align-bottom no-style border-end"
                        style="height: 7rem"
                      >
                        <p class="fs-7 m-0">
                          {{ imkp?.deptHeadKustodianNama || "-" }}
                        </p>
                      </td>
                      <td class="text-center align-bottom border-end">
                        <p class="fs-7 m-0">
                          {{ imkp?.deptHeadKustodianJabatan || "-" }}
                        </p>
                      </td>
                      <td class="text-center align-bottom border-end">
                        <p class="fs-7 m-0">
                          {{
                            imkp?.deptHeadKustodianTanggal
                              ? moment(
                                  new Date(imkp?.deptHeadKustodianTanggal),
                                ).format("DD MMMM YYYY")
                              : "-"
                          }}
                        </p>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <div class="row">
                          <div class="col-4">
                            <p class="fs-8 fw-bold m-0 text-center">
                              STC Dept. Head
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="fs-8 fw-bold m-0 text-center">
                              {{
                                getOHSDeptHeadTitle(
                                  imkp?.deptHeadKustodianTanggal
                                    ? new Date(imkp.deptHeadKustodianTanggal)
                                    : new Date(),
                                )
                              }}
                            </p>
                          </div>
                          <div class="col-4">
                            <p class="fs-8 fw-bold m-0 text-center">
                              {{
                                getKepalaTeknikTambangTitle(
                                  imkp?.deptHeadKustodianTanggal
                                    ? new Date(imkp.deptHeadKustodianTanggal)
                                    : new Date(),
                                )
                              }}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="text-center align-bottom no-style border-end p-0"
                        colspan="4"
                        style="height: 7rem"
                      >
                        <div class="row">
                          <div
                            class="col-4 d-flex align-bottom text-center justify-content-center border-end"
                            style="height: 7rem; align-items: flex-end"
                          >
                            <p class="fs-7 m-0">Wiga Wyadha Sutra</p>
                          </div>
                          <div
                            class="col-4 d-flex align-bottom text-center justify-content-center border-end"
                            style="height: 7rem; align-items: flex-end"
                          >
                            <p class="fs-7 m-0">
                              {{
                                getOHSDeptHeadName(
                                  imkp?.deptHeadKustodianTanggal
                                    ? new Date(imkp.deptHeadKustodianTanggal)
                                    : new Date(),
                                )
                              }}
                            </p>
                          </div>
                          <div
                            class="col-4 d-flex align-bottom text-center justify-content-center"
                            style="height: 7rem; align-items: flex-end"
                          >
                            <p class="fs-7 m-0">
                              {{
                                getKepalaTeknikTambangName(
                                  imkp?.deptHeadKustodianTanggal
                                    ? new Date(imkp.deptHeadKustodianTanggal)
                                    : new Date(),
                                )
                              }}
                            </p>
                          </div>
                        </div>
                        <p class="fs-7 m-0"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <div
          class="bg-white w-100 border border-1 shadow-sm p-2 rounded-4"
          style="min-height: 60vh"
        >
          <div class="d-flex justify-content-between px-4 pt-4 align-items-end">
            <div
              class="col-md-6 d-flex"
              style="
                padding-left: 0.5rem;
                padding-top: 0.5rem;
                align-items: flex-start;
              "
            >
              <img
                src="../../assets/images/borneo-indobara-icon.png"
                alt="logo-borneo-indobara"
                class="img-fluid"
                style="width: 13%"
              />
              <div style="padding-top: 2%">
                <h5 class="fw-bold">PT BORNEO INDOBARA</h5>
              </div>
            </div>
            <img
              src="../../assets/logo-sinisaja.png"
              alt="logo-sini-saja"
              class="img-fluid"
              style="width: 10%"
            />
          </div>
          <h6 class="fw-bold text-end text-nowrap mt-2">
            BIB-HSE-PPO-F-071-02
          </h6>
          <div class="container p-4">
            <h1 class="text-center mb-3 font-inter font-bold text-3xl">
              PENGAWASAN & PENANGGUNG JAWAB KEGIATAN PROYEK
            </h1>
            <p
              class="text-center fs-8 mb-3"
              style="font-family: 'Inter-Regular'"
            >
              Sebagai persyaratan untuk melaksanakan kegiatan proyek di dalam
              area kerja PT Borneo Indobara
            </p>
            <div class="rounded shadow-sm mb-4">
              <table class="table table-striped w-100 rounded mb-0">
                <tbody>
                  <TableComponent
                    :data="informasiProyek"
                    :column="2"
                    :subTitle="true"
                    title="A. INFORMASI PROYEK"
                  />
                </tbody>
              </table>
              <table class="table table-striped w-100 rounded mb-0">
                <tbody>
                  <tr></tr>
                  <TableComponent
                    :data="kontraktorPelaksana"
                    :column="4"
                    :subTitle="true"
                    title="B. KONTRAKTOR PELAKSANA"
                    name="Nama"
                    email="Email"
                    phone="Nomor Telepon (WA)"
                  />
                </tbody>
              </table>
              <table class="table table-striped w-100 rounded mb-0">
                <tbody>
                  <tr></tr>
                  <TableComponent
                    :data="kustodian"
                    :column="4"
                    :subTitle="true"
                    title="C. KUSTODIAN"
                    name="Nama"
                    departemen="Departemen"
                    email="Email"
                    phone="Nomor Telepon (WA)"
                  />
                </tbody>
              </table>
              <table class="table table-striped w-100 rounded mb-0">
                <tbody>
                  <tr></tr>
                  <TableComponent
                    :data="historikalStatistik"
                    :column="2"
                    :subTitle="true"
                    title="D. HISTORIKAL STATISTIK"
                  />
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-danger w-25 fs-8 fw-bold"
                  @click="clickTerbitkan"
                  v-if="
                    imkp.status == statusIMKPEnum.DOCUMENT_COMPLETE &&
                    masaBerlaku != null
                  "
                >
                  Terbitkan
                </button>
                <button
                  class="btn btn-danger w-25 fs-8 fw-bold"
                  v-if="
                    imkp.status == statusIMKPEnum.PENERBITAN_IMKP &&
                    masaBerlaku != null
                  "
                  disabled
                >
                  Proses Penerbitan IMKP
                </button>
                <button
                  class="btn btn-danger w-25 fs-8 fw-bold"
                  v-if="masaBerlaku === null"
                  disabled
                >
                  IMKP belum bisa diterbitkan karena CoC belum terbit
                </button>
                <button
                  class="btn btn-danger w-25 fs-8 fw-bold"
                  v-if="
                    imkp.status == statusIMKPEnum.IMKP_PUBLISHED ||
                    imkp.status == statusIMKPEnum.BAST_PROCESS ||
                    imkp.status == statusIMKPEnum.IMKP_DONE
                  "
                  @click="downloadFileEsign(imkp.documentIdImkp)"
                >
                  Download Dokumen IMKP
                </button>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "@/GlobalDataMixin";
import {
  API_BASE_URL,
  CMS_DOWNLOAD_ESIGN,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_IMKP_DETAIL,
  CMS_SET_IMKP_PUBLISH,
  CMS_VIEW_IMAGE,
} from "@/constants";
import { getSIOByIDContractor } from "@/utilities/globalFunction";
import axios from "axios";
import Swal from "sweetalert2";
import TableComponent from "./components/TableComponent.vue";
import { levelEnum } from "@/utilities/enum";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { formatSubLokasiDisplay } from "./core/subLokasiHelpers";
import {
  getKepalaTeknikTambangName,
  getKepalaTeknikTambangTitle,
} from "@/config/tempKepalaTeknikTambang";
import {
  getOHSDeptHeadName,
  getOHSDeptHeadTitle,
} from "@/config/tempOHSDeptHead";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_publish = API_BASE_URL + CMS_SET_IMKP_PUBLISH;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;
export default {
  name: "PreviewImkpPage",
  mixins: [GlobalDataMixin],
  components: { DefaultLayout, TableComponent },
  data() {
    return {
      isLoading: false,
      imkp: [],
      pjo: {},
      durasi: null,
      detailIzin: [],
      persyaratanKhusus: [],
      informasiProyek: [],
      kontraktorPelaksana: [],
      kustodian: [],
      historikalStatistik: [],
      ttdPjoFile: null,
      role: null,
      kontraktorNama: null,
      masaBerlaku: null,
    };
  },
  mounted() {
    this.role = this.userData.role.includes("ADMIN")
      ? levelEnum.ADMIN
      : this.userData.role.includes("OHS")
      ? levelEnum.OHS
      : this.userData.role.includes("reporter")
      ? levelEnum.REPORTER
      : this.userData.role === levelEnum.KONTRAKTOR
      ? levelEnum.KONTRAKTOR
      : levelEnum.ISAFE;

    if (this.role !== levelEnum.ADMIN && this.role !== levelEnum.OHS) {
      this.$router.push("/dashboard");
    }

    this.getIMKP(this.$route.params.id);
  },
  methods: {
    getKepalaTeknikTambangName,
    getKepalaTeknikTambangTitle,
    getOHSDeptHeadName,
    getOHSDeptHeadTitle,
    async getIMKP(id) {
      try {
        this.isLoading = true;

        let params = {
          id: id,
        };

        const result = await axios.get(url_imkp_detail, {
          params: params,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        const res = result.data.data[0];

        if (res) {
          if (
            res.status === statusIMKPEnum.DRAFT ||
            res.status === statusIMKPEnum.UNDER_REVIEW ||
            res.status === statusIMKPEnum.NEED_REVISION
          ) {
            this.$router.push("/dashboard");
          }
          this.imkp = res;

          const mulai = new Date(res.tanggalMulaiPekerjaan);
          const selesai = new Date(res.tanggalSelesaiPekerjaan);

          if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
            const diffTime = selesai.getTime() - mulai.getTime();

            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            this.durasi = Math.round(diffDays) + " Hari";
          } else {
            this.durasi = "-";
          }

          const persyaratanKhusus = Object.entries(res.assets)
            .map(([key, value]) => ({
              ...value,
              key: key,
              id: parseInt(key.match(/\d+/)[0], 10),
              name:
                key === "assets_c_q1"
                  ? "Kontrak / PO / NOA / SI <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q2"
                  ? "Daftar Dokumen Legal Perusahaan (IUJP/SIUP/IUJK) dan CoC <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q3"
                  ? "Metode Kerja <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q4"
                  ? "Identifikasi Bahaya dan Pengendalian Resiko <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q5"
                  ? "Daftar pekerja dan lampiran bukti kompetensi, sertifikat dll <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q6"
                  ? "Daftar sarana prasarana instalasi dan peralatan dan komisioning <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q7"
                  ? "Standar Operasional Prosedur / Analisa Kerja Aman (AKA) <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q8"
                  ? "HSE Plan (Inspeksi, Safety Talk, Observasi & pelatihan keselamatan (Emergency Drill)) <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q9"
                  ? "Manajemen Perubahan (MOC)"
                  : key === "assets_c_q10"
                  ? "Water Management Plan"
                  : key === "assets_c_q11"
                  ? "Hydrocarbon Management Plan"
                  : key === "assets_c_q12"
                  ? "Emergency Response Plan <span class='text-danger fs-9'>(wajib ada)</span>"
                  : key === "assets_c_q13"
                  ? "Struktur Organisasi Proyek <span class='text-danger fs-9'>(wajib ada)</span>"
                  : null,
            }))
            .sort((a, b) => a.id - b.id);

          this.persyaratanKhusus = Array.from({ length: 7 }, (_, i) => {
            const firstItem = persyaratanKhusus.find(
              (item) => item.id === i + 1,
            );
            const secondItem = persyaratanKhusus.find(
              (item) => item.id === i + 1 + 7,
            );
            return [firstItem, secondItem || null];
          });

          const sio = await getSIOByIDContractor(res.idKontraktor);
          this.masaBerlaku = sio.data.masaBerlaku;

          this.getKontraktor(res.idKontraktor);
          await this.getKelengkapan(sio.data.id, sio);
        }
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data detail IMKP!",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getKelengkapan(id, sio) {
      try {
        const res = await axios.get(url_get_kelengkapan + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        if (sio.data.downloadUrlPjo != null) {
          this.pjo.name = res.data.namaPjo;
          this.pjo.jabatan = res.data.jabatanPjo;
          this.pjo.ttd = res.data.ttdPjo;
        }
        if (res.data.ttdPjo !== "" && res.data.ttdPjo) {
          this.ttdPjoFile = API_BASE_URL + CMS_VIEW_IMAGE + res.data.ttdPjo;
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kelengkapan!",
        });
      }
    },
    async getKontraktor(id) {
      try {
        const res = await axios.get(url_kontraktor + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        if (res) {
          const kontaktor = res.data.detailKontraktor;
          const kontraktorName = kontaktor.namaKontraktor;
          this.kontraktorNama = kontraktorName;
          const jenis = kontaktor.jenis;
          const nomorIzinUsaha =
            kontaktor.jenis.toLocaleLowerCase() === "non inti"
              ? kontaktor.nib
              : kontaktor.iujp;
          if (!this.pjo.name) {
            this.pjo.name = kontaktor.namaPjo;
          }
          if (!this.pjo.jabatan)
            this.pjo.jabatan = "Penanggung Jawab Operasional";

          this.detailIzin = [
            {
              id: 1,
              label: "Kontraktor / Subkontraktor",
              value: kontraktorName,
            },
            {
              id: 2,
              label: "Nama Pemegang Izin",
              value: this.pjo.name,
            },
            {
              id: 3,
              label: "Lokasi Kerja",
              value: this.imkp.lokasiKerja,
            },
            {
              id: 4,
              label: "Sub Lokasi Kerja",
              value: formatSubLokasiDisplay(this.imkp.subLokasi),
            },
            {
              id: 5,
              label: "Keterangan Lokasi Proyek",
              value: this.imkp.keteranganLokasiKerja,
            },
            {
              id: 6,
              label: "Judul Proyek",
              value: this.imkp.judulProyek,
            },
            {
              id: 7,
              label: "Mulai Pekerjaan",
              value: this.imkp.tanggalMulaiPekerjaan
                ? moment(new Date(this.imkp.tanggalMulaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 8,
              label: "Selesai Pekerjaan",
              value: this.imkp.tanggalSelesaiPekerjaan
                ? moment(new Date(this.imkp.tanggalSelesaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 9,
              label: "Durasi Pekerjaan",
              value: this.durasi,
            },
            {
              id: 10,
              label: "Nomor Izin",
              value:
                this.imkp.nomorIzin != null
                  ? this.imkp.nomorIzin
                  : `IMKP-${new Date().getFullYear()}-Generate by System`,
            },
          ];

          this.informasiProyek = [
            {
              id: 1,
              label: "Judul Proyek",
              value: this.imkp.judulProyek,
            },
            {
              id: 2,
              label: "Nomor Izin",
              value: `IMKP-${new Date().getFullYear()}-Generate by System`,
            },
            {
              id: 3,
              label: "Mulai Pekerjaan",
              value: this.imkp.tanggalMulaiPekerjaan
                ? moment(new Date(this.imkp.tanggalMulaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 4,
              label: "Selesai Pekerjaan",
              value: this.imkp.tanggalSelesaiPekerjaan
                ? moment(new Date(this.imkp.tanggalSelesaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 5,
              label: "Durasi Pekerjaan",
              value: this.durasi,
            },
            {
              id: 6,
              label: "Kontraktor / Subkontraktor",
              value: kontraktorName,
            },
            {
              id: 7,
              label: "Nama Direktur Utama",
              value: this.imkp.namaDirekturUtama,
            },
            {
              id: 8,
              label: "Jenis & Nomor Izin Usaha",
              value: jenis + " & " + nomorIzinUsaha,
            },
          ];

          this.kontraktorPelaksana = [
            {
              id: 1,
              label: "Nama PJO",
              name: this.pjo.name,
              email: this.imkp.emailPjo,
              phone: this.imkp.noTeleponPjo,
            },
            {
              id: 2,
              label: "Nama Pengawas Operasional",
              name: this.imkp.namaPengawasOperasional
                ? JSON.parse(this.imkp.namaPengawasOperasional)
                : [],
              email: this.imkp.emailPengawasOperasional
                ? JSON.parse(this.imkp.emailPengawasOperasional)
                : [],
              phone: this.imkp.noTeleponPengawasOperasional
                ? JSON.parse(this.imkp.noTeleponPengawasOperasional)
                : [],
            },
            {
              id: 3,
              label: "Nama Pengawas Teknis",
              name: this.imkp.namaPengawasTeknis
                ? JSON.parse(this.imkp.namaPengawasTeknis)
                : [],
              email: this.imkp.emailPengawasTeknis
                ? JSON.parse(this.imkp.emailPengawasTeknis)
                : [],
              phone: this.imkp.noTeleponPengawasTeknis
                ? JSON.parse(this.imkp.noTeleponPengawasTeknis)
                : [],
            },
            {
              id: 4,
              label: "Nama Tenaga Teknis Kompeten",
              name: this.imkp.namaTenagaTeknisKompeten
                ? JSON.parse(this.imkp.namaTenagaTeknisKompeten)
                : [],
              email: this.imkp.emailTenagaTeknisKompeten
                ? JSON.parse(this.imkp.emailTenagaTeknisKompeten)
                : [],
              phone: this.imkp.noTeleponTenagaTeknisKompeten
                ? JSON.parse(this.imkp.noTeleponTenagaTeknisKompeten)
                : [],
            },
            {
              id: 5,
              label: "Nama Hse Officer",
              name: this.imkp.namaHseOfficer
                ? JSON.parse(this.imkp.namaHseOfficer)
                : [],
              email: this.imkp.emailHseOfficer
                ? JSON.parse(this.imkp.emailHseOfficer)
                : [],
              phone: this.imkp.noTeleponHseOfficer
                ? JSON.parse(this.imkp.noTeleponHseOfficer)
                : [],
            },
          ];

          this.kustodian = [
            {
              id: 1,
              label: "Nama Departemen Kustodian",
              departemen: [],
              name: this.imkp.namaDepartemenKustodian
                ? JSON.parse(this.imkp.namaDepartemenKustodian)
                : [],
              email: null,
              phone: null,
            },
            {
              id: 2,
              label: "Kepala Departemen Kustodian",
              departemen: this.imkp.departmentKepalaDepartemenKustodian
                ? JSON.parse(this.imkp.departmentKepalaDepartemenKustodian)
                : [],
              name: this.imkp.namaKepalaDepartemenKustodian
                ? JSON.parse(this.imkp.namaKepalaDepartemenKustodian)
                : [],
              email: this.imkp.emailKepalaDepartemenKustodian
                ? JSON.parse(this.imkp.emailKepalaDepartemenKustodian)
                : [],
              phone: this.imkp.noTeleponKepalaDepartemenKustodian
                ? JSON.parse(this.imkp.noTeleponKepalaDepartemenKustodian)
                : [],
            },
            {
              id: 3,
              label: "Pengawas Operasional",
              departemen: this.imkp.departmentKustodianPengawasOperasional
                ? JSON.parse(this.imkp.departmentKustodianPengawasOperasional)
                : [],
              name: this.imkp.namaKustodianPengawasOperasional
                ? JSON.parse(this.imkp.namaKustodianPengawasOperasional)
                : [],
              email: this.imkp.emailKustodianPengawasOperasional
                ? JSON.parse(this.imkp.emailKustodianPengawasOperasional)
                : [],
              phone: this.imkp.noTeleponKustodianPengawasOperasional
                ? JSON.parse(this.imkp.noTeleponKustodianPengawasOperasional)
                : [],
            },
            {
              id: 4,
              label: "Pengawas Teknis (Sipil)",
              departemen: this.imkp.departmentKustodianPengawasTeknisSipil
                ? JSON.parse(this.imkp.departmentKustodianPengawasTeknisSipil)
                : [],
              name: this.imkp.namaKustodianPengawasTeknisSipil
                ? JSON.parse(this.imkp.namaKustodianPengawasTeknisSipil)
                : [],
              email: this.imkp.emailKustodianPengawasTeknisSipil
                ? JSON.parse(this.imkp.emailKustodianPengawasTeknisSipil)
                : [],
              phone: this.imkp.noTeleponKustodianPengawasTeknisSipil
                ? JSON.parse(this.imkp.noTeleponKustodianPengawasTeknisSipil)
                : [],
            },
            {
              id: 5,
              label: "Pengawas Teknis (Elektrikal)",
              departemen: this.imkp.departmentKustodianPengawasElektrikal
                ? JSON.parse(this.imkp.departmentKustodianPengawasElektrikal)
                : [],
              name: this.imkp.namaKustodianPengawasElektrikal
                ? JSON.parse(this.imkp.namaKustodianPengawasElektrikal)
                : [],
              email: this.imkp.emailKustodianPengawasElektrikal
                ? JSON.parse(this.imkp.emailKustodianPengawasElektrikal)
                : [],
              phone: this.imkp.noTeleponKustodianPengawasElektrikal
                ? JSON.parse(this.imkp.noTeleponKustodianPengawasElektrikal)
                : [],
            },
            {
              id: 6,
              label: "Pengawas Teknis (Mekanikal)",
              departemen: this.imkp.departmentKustodianPengawasMekanikal
                ? JSON.parse(this.imkp.departmentKustodianPengawasMekanikal)
                : [],
              name: this.imkp.namaKustodianPengawasMekanikal
                ? JSON.parse(this.imkp.namaKustodianPengawasMekanikal)
                : [],
              email: this.imkp.emailKustodianPengawasMekanikal
                ? JSON.parse(this.imkp.emailKustodianPengawasMekanikal)
                : [],
              phone: this.imkp.noTeleponKustodianPengawasMekanikal
                ? JSON.parse(this.imkp.noTeleponKustodianPengawasMekanikal)
                : [],
            },
            {
              id: 7,
              label: "PIC OHS",
              departemen: [],
              name: this.imkp.namaKustodianPicOhs
                ? JSON.parse(this.imkp.namaKustodianPicOhs)
                : [],
              email: this.imkp.emailKustodianPicOhs
                ? JSON.parse(this.imkp.emailKustodianPicOhs)
                : [],
              phone: this.imkp.noTeleponKustodianPicOhs
                ? JSON.parse(this.imkp.noTeleponKustodianPicOhs)
                : [],
            },
          ];

          this.historikalStatistik = [
            {
              id: 1,
              label: "Insiden, Hazard Report, Inspeksi",
              value: this.imkp.historikalInsiden
                ? JSON.parse(this.imkp.historikalInsiden).map(
                    (item) => `Departemen ${item}`,
                  )
                : [],
            },
            {
              id: 2,
              label: "PIC untuk tindak lanjut NC",
              value: this.imkp.historikalPicTindakLanjut
                ? JSON.parse(this.imkp.historikalPicTindakLanjut)
                : [],
            },
          ];
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kontraktor!",
        });
      }
    },
    clickTerbitkan() {
      Swal.fire({
        title: "Terbitkan IMKP",
        text: `Apakah anda yakin akan menerbitkan data IMKP ini`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.doSubmit();
        }
      });
    },
    async doSubmit() {
      try {
        let bodyJson = {
          id: parseInt(this.$route.params.id),
          status: 4,
        };
        await axios.post(url_publish, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        Swal.fire({
          title: "Penerbitan IMKP berhasil",
          text: "IMKP berhasil diterbitkan!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          this.$router.push({
            path: "/approval-imkp",
            query: this.$route.query,
          });
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat penerbitan IMKP!",
        });
      }
    },
    downloadFileEsign(id) {
      this.isLoading = true;
      let filename = `File IMKP ${this.kontraktorNama}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },
  },
};
</script>

<style scoped>
tr td:first-child:not(.no-style) {
  background: #f8e3e5;
}

tr td:first-child p {
  font-weight: 600;
}
</style>
